import { FormattedMessage } from 'react-intl'
import {KTSVG} from '../../../../../../_metronic/helpers'
import {useListView} from '../../core/ListViewProvider'
import {OrdersListFilter} from './OrdersListFilter'

const OrdersListToolbar = () => {
  const {setItemIdForUpdate} = useListView()
  const openAddOrderModal = () => {
    setItemIdForUpdate(null)
  }

  return (
    <div className='d-flex justify-content-end' data-kt-order-table-toolbar='base'>
      <OrdersListFilter />

      {/* begin::Export */}
      <button type='button' className='btn btn-light-primary me-3'>
        <KTSVG path='/media/icons/duotune/arrows/arr078.svg' className='svg-icon-2' />
        <FormattedMessage id='TABLE.GENERAL.EXPORT' />      </button>
      {/* end::Export */}

      {/* begin::Add order */}
      <button type='button' className='btn btn-primary' onClick={openAddOrderModal}>
        <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-2' />
        <FormattedMessage id='ORDER.TABLE.CREATEORDER' />
      </button>
      {/* end::Add order */}
    </div>
  )
}

export {OrdersListToolbar}
